<template>
  <div>
    <!-- 通知预览 -->
    <el-dialog :title="$t('message.noticeLook')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1200px" center>
      <div class="content">
        <div class="title">
          {{ datas.title }}
        </div>
        <div v-html="datas.content"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="noticeStore" v-if="$route.name == 'announcement'">{{ $t("message.ok")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  props: {
    datas: { type: Object },
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    noticeStore() {
      this.$confirm(
        "请再次确认是否发送通知，通知一经发送无法取消",
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.cancel"),
          cancelButtonText: this.$t("message.confirm"),
          cancelButtonClass: 'red',
          confirmButtonClass: 'dark',
          type: "warning",
          center: true,
        }
      )
        .then(() => {

        })
        .catch(() => {
          this.$api.siteConfiguration.noticeStore(this.datas).then((res) => {
            this.$message.success(res.msg);
            this.dialogVisible = false;
            this.$router.push("/menu3_config_notice");
          });
        });
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  padding: 24px;
  background-color: #f8f8f8;
  border-radius: 8px;

  /deep/ div {
    img {
      max-width: 100%;
    }
  }

  .title {
    text-align: center;
    margin-bottom: 20px;
    font-size: 20px;
  }
}
</style>